import { useContext, useEffect, useState } from 'react';
import Rupee from '../../../Assets/rupee.svg';
import { EditVariantFormContext } from '../../../Context/EditVariantFormContext';
import { useSelector } from 'react-redux';
import Input from '../../../Components/Input/Input';

function VariantDetails() {
    const {
        formErrors,
        setFormErrors,
        formInputs,
        setFormInputs,
    } = useContext(EditVariantFormContext);
    
    const [productCategory, setProductCategory] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormInputs({ ...formInputs, [name]: value });
    };

    const selectedVariant = useSelector((state) => state.inventoryManagement.selectedVariant);
    const { products } = useSelector((state) => state.inventoryManagement.products);

    // Normalize helper for consistent category matching
    const norm = (s = '') =>
        String(s).trim().toLowerCase().replace(/[^a-z0-9]+/g, '');

    useEffect(() => {
        if (Object.keys(selectedVariant || {}).length === 0) return;

        const foundProduct = products?.find(item =>
            item?.varients?.some(variant => variant.id === selectedVariant.id)
        );

        setProductCategory(foundProduct?.product?.productCategory || '');
    }, [selectedVariant, products]);

    const isBeauty = norm(productCategory) === norm('Beauty & Personal Care');

    return (
        <div className="flex flex-col gap-4 border border-[#EAEAEA] p-5 rounded-xl">
            <h1 className='font-semibold text-[18px] leading-[26px] select-none'>
                Edit Variant Details
            </h1>

            <div className="grid grid-cols-2 gap-x-2 gap-y-4">
                {/* MRP */}
                <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-between">
                        <label
                            className='w-fit select-none cursor-pointer font-medium text-base text-[#121212]'
                            htmlFor="VarientMrp"
                        >
                            MRP<span className="text-[#DC2626]">*</span>
                        </label>
                        {formErrors.VarientMrp && (
                            <p className='text-[14px] leading-5 text-[#DC2626] select-none'>
                                {formErrors.VarientMrp}
                            </p>
                        )}
                    </div>

                    <div className="h-14 flex items-center gap-1 px-2 py-[6px] bg-[#F5F5F5] border border-[#EAEAEA] rounded-lg focus-within:border-primaryColor">
                        <div className="w-6 h-6 flex items-center justify-center">
                            <img src={Rupee} alt="" />
                        </div>

                        <input
                            id='VarientMrp'
                            name='VarientMrp'
                            className='w-[calc(100%-24px)] outline-none bg-transparent font-normal text-base text-[#121212]'
                            type="number"
                            placeholder='0.00'
                            value={formInputs.VarientMrp}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                {/* Selling Price */}
                <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-between">
                        <label
                            className='w-fit select-none cursor-pointer font-medium text-base text-[#121212]'
                            htmlFor="VarientPrice"
                        >
                            Selling Price<span className="text-[#DC2626]">*</span>
                        </label>
                        {formErrors.VarientPrice && (
                            <p className='text-[14px] leading-5 text-[#DC2626] select-none'>
                                {formErrors.VarientPrice}
                            </p>
                        )}
                    </div>

                    <div className="h-14 flex items-center gap-1 px-2 py-[6px] bg-[#F5F5F5] border border-[#EAEAEA] rounded-lg focus-within:border-primaryColor">
                        <div className="w-6 h-6 flex items-center justify-center">
                            <img src={Rupee} alt="" />
                        </div>

                        <input
                            id='VarientPrice'
                            name='VarientPrice'
                            className='w-[calc(100%-24px)] outline-none bg-transparent font-normal text-base text-[#121212]'
                            type="number"
                            placeholder='0.00'
                            value={formInputs.VarientPrice}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                {/* Size / Volume */}
                <Input 
                    labelText={isBeauty ? 'Volume' : 'Size'}
                    errorText={formErrors.VarientSize}
                    inputOptions={{
                        type: 'text',
                        id: 'VarientSize',
                        name: 'VarientSize',
                        placeholder: isBeauty ? 'Enter volume (e.g., 10ml)' : 'Enter variant size',
                        value: formInputs.VarientSize,
                        onChange: handleChange
                    }}
                    required
                />

                {/* Color (optional for Beauty) */}
                <Input
                    labelText='Color'
                    errorText={formErrors.VarientColor}
                    inputOptions={{
                        type: 'text',
                        id: 'VarientColor',
                        name: 'VarientColor',
                        placeholder: 'Enter variant color',
                        value: formInputs.VarientColor,
                        onChange: handleChange
                    }}
                    required={!isBeauty}
                />

                {/* Quantity */}
                <Input
                    labelText='Quantity'
                    errorText={formErrors.VarientQuantity}
                    inputOptions={{
                        type: 'text',
                        id: 'VarientQuantity',
                        name: 'VarientQuantity',
                        placeholder: 'Enter quantity',
                        value: formInputs.VarientQuantity,
                        onChange: handleChange
                    }}
                    required
                />

                {/* SKU */}
                <Input
                    labelText='SKU'
                    errorText={formErrors.Sku}
                    inputOptions={{
                        type: 'text',
                        id: 'Sku',
                        name: 'Sku',
                        placeholder: 'Eg: UGG-BB-PUR-07',
                        value: formInputs.Sku,
                        onChange: handleChange
                    }}
                />
            </div>
        </div>
    );
}

export default VariantDetails;
